import { render } from "./BaseTableMeasurements.vue?vue&type=template&id=d917761c"
import script from "./BaseTableMeasurements.vue?vue&type=script&lang=js"
export * from "./BaseTableMeasurements.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__